/**
 * web.app-secura.com : Secura sur ordinateur (QR code).
 * Shell identique au /dashboard AdminRH : sidebar + navbar, menu Projets et Schedule.
 */
export const isWebHost = () =>
  typeof window !== 'undefined' && window.location.hostname.startsWith('web.');

import { useEffect, useState } from 'react';

/** Largeur de la colonne de contenu sur grand écran. */
export const WEB_MAX_WIDTH = 960;
/** Liste des projets (colonne conversations) à partir de 1024 px. */
export const WEB_SIDEBAR_WIDTH = 380;
/** Largeur du menu latéral (élargi pour le bloc profil). */
export const WEB_MENU_WIDTH = 320;
/** Largeur du menu latéral replié (ml-20). */
export const WEB_MENU_WIDTH_COLLAPSED = 80;
/** Hauteur du navbar. */
export const WEB_NAVBAR_HEIGHT = 64;
/** Marge autour de la card messagerie (espace vs sidebar + navbar). */
export const WEB_CHAT_CARD_PAD = 38;
const WIDE_QUERY = '(min-width: 1024px)';

export function useIsWide() {
  const get = () => typeof window !== 'undefined' && window.matchMedia(WIDE_QUERY).matches;
  const [wide, setWide] = useState(get);
  useEffect(() => {
    const mq = window.matchMedia(WIDE_QUERY);
    const on = () => setWide(mq.matches);
    mq.addEventListener('change', on);
    return () => mq.removeEventListener('change', on);
  }, []);
  return wide;
}

const ALLOWED = /^\/(login|projets|tasks|horaire|profil)(\/|$)/;

/** Page accessible sur web.app-secura.com ? */
export const isAllowedOnWebHost = (pathname) => ALLOWED.test(pathname || '');

/** Session d'un ordinateur « personnel » connecté par QR code (claims lds / ldm du jeton). */
export const isPersonalLinkedSession = (token) => {
  try {
    const payload = JSON.parse(atob(String(token).split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return !!payload?.lds && payload?.ldm === 'personal';
  } catch {
    return false;
  }
};
